import React from 'react'
import { connect } from 'react-redux'
import { RootState } from 'Store'
import { selectList, selectListEvent } from 'Store/coupon/selector'
import { selectCurrentUser } from 'Store/user/selector'
import HomePageLayout from 'Pages/Layout/PageLayout'
import Rewards from './components/Rewards'

type Props = {} & ReduxProps

const PointMemberReward: React.FunctionComponent<Props> = props => {
  return (
    <>
      <HomePageLayout selected="point-reward" title="จัดการของรางวัล">
        <Rewards />
      </HomePageLayout>
    </>
  )
}

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
    dataList: selectList(state),
    listEvent: selectListEvent(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

export default connect(mapStateToProps)(PointMemberReward)
